import { useEffect, useState } from 'react';
import useScript from '../hooks/useScript';
import { postData } from '../backend';
import useUser from '../hooks/useUser';
import { useLocation } from 'react-router-dom';


function HubspotVisitor() {

  const { user } = useUser();

  const [hasConfigured, setHasConfigured] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const scriptLoaded = useScript(hasConfigured ? "https://js.hs-scripts.com/23509132.js" : null);

  const location = useLocation();

  useEffect(() => {
    if (hasConfigured)
      return;

    //@ts-ignore
    window.hsConversationsSettings = {
      loadImmediately: false
    };

    setHasConfigured(true);
  }, [hasConfigured]);

  useEffect(() => {
    //@ts-ignore
    const HubSpotConversations = window.HubSpotConversations;

    if (location.pathname.startsWith("/s/") || location.pathname.startsWith("/w/"))
      HubSpotConversations?.widget.remove();
    else
      HubSpotConversations?.widget.load();

  }, [location]);

  useEffect(() => {
    if (!scriptLoaded || !hasConfigured || !user || hasLoaded)
      return;

    function onConversationsAPIReady() {
      //@ts-ignore
      const HubSpotConversations = window.HubSpotConversations;

      postData("/auth/hubspot-visitor-token/")
        .then(({ token }) => {
          //@ts-ignore
          window.hsConversationsSettings = {
            loadImmediately: false,
            identificationEmail: user!.email,
            identificationToken: token,
          };

          if (!location.pathname.startsWith("/s/"))
            HubSpotConversations.widget.load();
        })
        .catch(console.error);
    }

    //@ts-ignore
    if (window.HubSpotConversations) {
      onConversationsAPIReady();
    } else {
      //@ts-ignore
      window.hsConversationsOnReady = [onConversationsAPIReady];
    }

    setHasLoaded(true);

  }, [user, scriptLoaded, hasConfigured, hasLoaded, location]);

  return null;
}

export default HubspotVisitor;
